import { ValidatingInput, InputComponentProps } from '~/components/validating-input';

export const DateOfBirth = (props: InputComponentProps) => {
  const validate = ({ value }) => {
    const today = new Date();
    const date = new Date(value);

    if (value.trim().length < 1) return 'Please enter your date of birth';
    if (date > today) return 'Date of birth cannot be in the future';
    if (date.getFullYear() < 1900) return 'Date of birth cannot be before 1900';
    const eighteenYearsAgo = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
    if (date > eighteenYearsAgo) return 'You must be at least 18 years old';
    return true;
  };

  return (
    <ValidatingInput
      label="Date of birth"
      name="dateOfBirth"
      type="date"
      requirements="Used for a soft credit check — this won't impact your credit score"
      validate={validate}
      {...props}
    />
  );
};
